import { Link } from "gatsby";
import "./styles.scss";
import { ProductListProps } from "./types";

const ProductList = ({ mobileScroll, products }: ProductListProps) => {
  return (
    <div className={`productList ${mobileScroll ? "productList--hasMobileScroll" : ""} `}>
      {products.map(function (product, index) {
        return (
          <Link
            className="productCard"
            key={`products-${index}`}
            to={`/travel-supplies/${product.id}`}
            title={product.title}>
            <img
              src={product.imageUrl}
              className="productCard__image"
              alt={product.title}
            />
            <div className="productCard__title">
              <b>{product.title}</b>
            </div>
            <div className="productCard__price">${product.price}</div>
          </Link>
        );
      })}
    </div>
  );
};

export default ProductList;
